/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { InputBase, SvgIcon, Paper, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { mdiCalculator } from '@mdi/js';

const useStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            background: theme.palette.primary.contrastText,
            color: theme.palette.primary.main
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
        },
        icon: {
            margin: "0.5em"
        }
    }
});

export interface BattleCalculatorFieldProps {
    fieldId: string;
    playerName: string;
    updatePlayerStrength: Function;
};

export const BattleCalculatorField = (props: BattleCalculatorFieldProps) => {
    const classes = useStyles();

    return (
        <Paper className={classes.root}>
            <SvgIcon className={classes.icon}>
                <path d={mdiCalculator} />
            </SvgIcon>
            <InputBase 
                className={classes.input}
                fullWidth
                id={props.fieldId}
                placeholder={"Add or subtract any modifiers."}                                 
                onChange={(event) => props.updatePlayerStrength(event)} 
            />
        </Paper>
    );
}
